import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import NumberFormat from 'react-number-format';

import { get } from 'lodash-es';

import { fieldShape } from './index.shape';
import { addClassName } from './index.utils';

import './index.scss';

/**
 * text field component
 * @param props
 * @returns {XML}
 * @constructor
 */
const InputNumberCommon = props => {
  const {
    field: { name, value },
    placeholder,
    disabled,
    decimalScale,
    thousandSeparator,
    allowNegative,
    decimalSeparator,
    prefix,
    suffix,
    isAllowed,
    eventEmitter,
    showError,
    existError,
    ...other
  } = props;

  const [localValue, setValueLocal] = useState(value != null ? value : '');

  // TODO observable value
  useEffect(() => {
    setValueLocal(value != null ? value : '');
  }, [value]);

  // on change value
  const onValueChange = event => setValueLocal(get(event, 'floatValue'));

  const onBlur = () => eventEmitter(localValue);

  return (
    <NumberFormat
      {...other} // eslint-disable-line react/jsx-props-no-spreading
      className={addClassName({ existError, showError })}
      name={name}
      placeholder={placeholder}
      disabled={disabled}
      isNumericString
      thousandSeparator={thousandSeparator}
      decimalSeparator={decimalSeparator}
      decimalScale={decimalScale}
      allowNegative={allowNegative}
      prefix={`${prefix} `}
      suffix={` ${suffix}`}
      isAllowed={isAllowed}
      value={localValue != null ? localValue : ''}
      onValueChange={onValueChange}
      onBlur={onBlur}
    />
  );
};

InputNumberCommon.propTypes = {
  field: PropTypes.shape(fieldShape),
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  decimalScale: PropTypes.number,
  thousandSeparator: PropTypes.string,
  decimalSeparator: PropTypes.string,
  allowNegative: PropTypes.bool,
  prefix: PropTypes.string,
  suffix: PropTypes.string,
  isAllowed: PropTypes.func,
  existError: PropTypes.bool,
  showError: PropTypes.bool,
  eventEmitter: PropTypes.func.isRequired,
};

InputNumberCommon.defaultProps = {
  field: {
    value: undefined,
  },
  decimalScale: 2,
  thousandSeparator: ',',
  decimalSeparator: '.',
  allowNegative: false,
  prefix: '',
  suffix: '',
  isAllowed: undefined,
  existError: false,
  showError: false,
  placeholder: '',
  disabled: false,
};

export default InputNumberCommon;
